import getElementAttribute from '../accessors/get-element-attribute';
import getLiveElement from '../accessors/get-live-element';
import DEFAULT_OPTIONS from '../constants/default-options';
import { UPDATE_LIVE_ONLY } from '../../hdrm/constants/update-strategies';
import setElementAttribute from './set-element-attribute';
import getPatchedResponsiveClass from '../helpers/get-patched-responsive-class';

const setResponsiveClass = ({
  elementId,
  className,
  value,
  breakpoint,
  options = DEFAULT_OPTIONS,
}) => {
  const currentClass =
    (options.strategy === UPDATE_LIVE_ONLY
      ? getLiveElement(elementId).getAttribute('class')
      : getElementAttribute(elementId, 'class')) || '';
  const newClass = getPatchedResponsiveClass({ currentClass, className, value, breakpoint });
  return setElementAttribute(elementId, 'class', newClass, options);
};

export default setResponsiveClass;
